// Browser-safe helper — no node imports.
export function publicPhotoUrl(subpath: string): string {
  const encoded = subpath.split("/").map(encodeURIComponent).join("/");
  return `/api/photos/file/${encoded}`;
}
